
import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import { cn } from '@/lib/utils';
import { AdSense } from './ui/adsense';
import { GoogleAdsToggleService } from '@/services/googleAdsToggleService';

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

const Layout = ({ children, className }: LayoutProps) => {
  const [showAds, setShowAds] = useState(false);
  const [adsLoading, setAdsLoading] = useState(true);

  useEffect(() => {
    const checkGoogleAdsToggle = async () => {
      try {
        const shouldShow = await GoogleAdsToggleService.shouldDisplayGoogleAds();
        setShowAds(shouldShow);
      } catch (error) {
        console.error('Error checking Google Ads toggle:', error);
        // Use safe default on error
        setShowAds(false);
      } finally {
        setAdsLoading(false);
      }
    };

    checkGoogleAdsToggle();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className={cn("flex-1", className)}>
        {children}
      </main>
      {!adsLoading && (
        <div className="container my-4">
          <AdSense 
            className="mb-4" 
            variant="responsive" 
            shouldDisplay={showAds}
          />
        </div>
      )}
      <footer className="py-6 md:py-8 border-t border-border/30">
        <div className="container flex flex-col gap-2 items-center justify-center text-center px-4">
          <p className="text-sm text-muted-foreground">
            AI Model Mind Space. Discover, explore, and contribute to the world of AI models.
          </p>
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} AIZen.tips. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">
            Made by SimpleTechX Inc.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
